import { NBSP } from 'shared/constants';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

interface INewbuildingBrokerMicrofrontFallbackModalSettings {
  title: string;
  description: string;
  buttonText: string;
  imageUrl?: string;
}

const DEFAULT_SETTINGS: INewbuildingBrokerMicrofrontFallbackModalSettings = {
  title: 'Что-то пошло не так',
  description: `Проверьте интернет и${NBSP}попробуйте ещё${NBSP}раз`,
  buttonText: 'Повторить',
};

export function useFallbackModalSettings(): INewbuildingBrokerMicrofrontFallbackModalSettings {
  const { config } = useApplicationContext();

  return (
    config.get<INewbuildingBrokerMicrofrontFallbackModalSettings>('newbuildingBroker.modalsMicrofrontFallback') ??
    DEFAULT_SETTINGS
  );
}
